module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    staticClass: "mapSnackbar",
    attrs: {
      "top": "",
      "color": "white",
      "absolute": "",
      "timeout": 0
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_c('font', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("\n      Marcá el centro de tu equipo\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-478ed2d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/new/DeviceCenterInputSnackbar.vue
// module id = 769
// module chunks = 24